import React, { Component } from "react";
import dali from "../images/dali_transparent.avif";
import stickers from "../images/stickers_chat.avif";

class StickerPack extends Component {
  render() {
    return (
      <div className="sticker-pack" id="stickerPack" ref={this.props.refName}>
        <div className="sticker-pack-header">
          <div>
            <div className="section-heading">
              <h1>Telegram</h1>
              <div className="shadow">Telegram</div>
            </div>

            <h2>
              Sticker Pack <i className="fab fa-telegram" />
            </h2>
          </div>
          <div>
            <img src={dali} alt="Dali the chinchilla sitting upright, is hands folded in front of his body" />
          </div>
        </div>

        <div className="sticker-pack-content">
          <div>
            <img src={stickers} alt="Screenshot of a telegram chat using the Chaos Chinchillas sticker set" />
          </div>
          <div className="text">
            <p>
              <a href="https://t.me/addstickers/chaoschinchillas">
                https://t.me/addstickers/chaoschinchillas
              </a>
            </p>
            <p>
              Sometimes words aren't enough to express all your moods and
              feelings. For this purpose, we created the Chaos Chinchillas
              sticker pack for Telegram! Just click the link above to add the
              adorable pack to your messenger and start enriching your friends
              and family with chinchilla stickers!
            </p>
            <p>
              If you have any suggestions for further stickers, feel free to
              contact us via our{" "}
              <a
                href="https://www.facebook.com/chaoschinchillas/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Facebook
              </a>{" "}
              or{" "}
              <a
                href="https://www.instagram.com/chaos_chinchillas/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Instagram
              </a>{" "}
              page, or send an email to{" "}
              <a href="mailto:hello@anja.codes">hello@anja.codes</a>.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default StickerPack;
